import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { myTimeUserApprovalState } from "my-time/states/user-approval-state";

export const useMyTimeUserApprovalState = () => {
  const state = useRecoilValue(myTimeUserApprovalState);
  const setState = useSetRecoilState(myTimeUserApprovalState);
  const resetState = useResetRecoilState(myTimeUserApprovalState);

  return {
    state,
    setState,
    resetState,
  };
};

export default useMyTimeUserApprovalState;
